import { useState } from "react"
import { Collapse, Space, Table } from "antd"
import Icon from "@ant-design/icons"
// import "../Faq/Faq.less"
// import "../Disclaimer/Disclaimer.less"
import ExpandIcon from "../../assets/ExpandIcon.svg"
import FormStore from "../../Configs/Store/forms"
import { DataLayerFn } from "../../Configs/API"
import DOMPurify from "dompurify"
import Image from "./Image"

const { Panel } = Collapse

const ExpandViewIcon = () => (
  <Image src={ExpandIcon} className="rotate90" alt={""} />
)

const CollapseViewIcon = () => (
  <Image src={ExpandIcon} className="rotate0" alt={""} />
)

const customExpandIcon = (
  props,
  from,
  calculateState,
  proccedModalState,
  apiDataState,
  question
) => {
  // console.info(props.isActive)
  if (props.isActive) {
    return <Icon component={ExpandViewIcon} />
  } else {
    return <Icon component={CollapseViewIcon} />
  }
}

const ExpandableCard = ({
  data,
  componentName,
  open,
  from,
  type,
  dataSet,
  dataType,
  ...props
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const clickEvent = (e, from, type, fStore, question, index) => {
    var subSection =
      FormStore.quoteScreen === true
        ? "Calculator-QuoteScreen"
        : "Calculator-Landing page"
    if (index === currentIndex) {
      setCurrentIndex(null)
    } else {
      setCurrentIndex(index)
    }
    try {
      if (e.target.closest(".ant-collapse-item-active") === null) {
        from === "FAQ"
          ? DataLayerFn(
            "FAQ_Selected||Calculator-Landing page|FAQs",
            fStore,
            question,
            question,
            "",
            ""
          )
          : DataLayerFn(
            `Disclaimer_Selected||${subSection}|Disclaimer`,
            fStore,
            "",
            "Disclaimer",
            "",
            ""
          )
      }
    } catch { }
  }

  return (
    <div className={componentName + "_CollapseRoot"}>
      <Space direction="vertical" className={componentName + "_VerticalSpace"}>
        {dataSet["SectionConfig"]["type"] === "faq" ? (
          dataSet.data.map((value, index) => (
            <div
              key={"ExpandCard_" + index}
              onClick={(e) => {
                console.log("Clicked: ", e)
                clickEvent(e, from, type, FormStore, value["title"], index)
              }}
            >
              <Collapse
                key={index}
                defaultActiveKey={null}
                expandIconPosition={"end"}
                activeKey={currentIndex}
                expandIcon={(props) =>
                  customExpandIcon(props, from, value["title"])
                }
              >
                <Panel
                  key={index}
                  forceRender={true}
                  header={
                    <div className="Faq_Header">
                      <h3
                        className={`Faq_Title ${currentIndex === index ? "bold" : ""
                          }`}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(value["title"]),
                        }}
                      />
                      {props.device === 1 && (
                        <Image
                          src={"./assets/FAQ_ExpandIcon.svg"}
                          className="ExpandIcon"
                          alt={""}
                          defer={true}
                        />
                      )}
                    </div>
                  }
                >
                  {
                    <>
                      {value["type"] === 2 ? (
                        <div className="Faq_TableCard">
                          <Table
                            className="border-faq-none"
                            bordered
                            size={"small"}
                            pagination={false}
                            dataSource={value["content"]["dataSource"]}
                            columns={value["content"]["columns"]}
                          />
                          <div
                            className={componentName + "_Content"}
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                value["content"]["extra"]
                              ),
                            }}
                          ></div>
                        </div>
                      ) : (
                        <div
                          className={componentName + "_Content"}
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(value["content"]),
                          }}
                        ></div>
                      )}
                    </>
                  }
                </Panel>
              </Collapse>
            </div>
          ))
        ) : (
          <div
            onClick={(e) => {
              console.log("Clicked: ", e)
              clickEvent(e, from, type, FormStore, "", "")
            }}
          >
            <Collapse
              defaultActiveKey={null}
              expandIconPosition={"end"}
              expandIcon={(props) =>
                customExpandIcon(props, from, "Disclaimer")
              }
            >
              <Panel
                header={
                  <div
                    className="PanelHead"
                    style={{ marginRight: 25 }}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize("Disclaimer"),
                    }}
                  />
                }
              >
                <>
                  {dataSet &&
                    dataSet.data.map((v, i) =>
                      dataType === "main"
                        ? (v.type === 1 || v.type === 3) && (
                          <div
                            key={"Disc_1_" + i}
                            className={`Disclaimers ${v.extra}`}
                            dangerouslySetInnerHTML={{ __html: v.content }}
                          />
                        )
                        : (v.type === 2 || v.type === 3) && (
                          <div
                            key={"Disc_1_" + i}
                            className={`Disclaimers ${v.extra}`}
                            dangerouslySetInnerHTML={{ __html: v.content }}
                          />
                        )
                    )}
                </>
              </Panel>
            </Collapse>
          </div>
        )}
      </Space>
    </div>
  )
}

export default ExpandableCard
